import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DivisionService from '../../services/Division/DivisionService';
import styles from './DivisionHome.module.css';
import noresfoundIcon from '../../assets/noresfoundIcon.png';

const DivisionHome = () => {
    const [divisions, setDivisions] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDivisions = async () => {
            try {
                const response = await DivisionService.GetDepartmentByDivisionId();
                if (response.data.status && response.data.object.departments) {
                    setDivisions(response.data.object.departments);
                }
                setLoading(false);
            } catch (error) {
                console.error('Error fetching divisions:', error);
                setLoading(false);
            }
        };

        fetchDivisions();
    }, []);

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loader}></div>
            </div>
        );
    }

    if (!divisions.length) {
        return (
            <div className={styles.notFoundContainer}>
                <img src={noresfoundIcon} alt="No results found" className={styles.notFoundImage} />
                <h2>No Departments Found</h2>
                <p>We couldn't find any department for this category.</p>
            </div>
        );
    }

    const handleDepartmentClick = (deptPublicUri) => {
        if (deptPublicUri && deptPublicUri.trim() !== '') {
            // Get current path and remove 'Departments' if it exists
            const currentPath = window.location.pathname;
            const basePath = currentPath.replace('/Departments', '');
            navigate(`${basePath}/Department/${deptPublicUri}`);
        }
    };

    return (
        <div className="container-custom py-4">
            <h1 className={styles.title}>Departments</h1>
            <div className={styles.divisionsList}>
                {divisions.map((division, index) => (
                    <div 
                    tabIndex={0}  
                    role="button"  
                    aria-label={`Go to ${division.deptName}`}  
                        key={index} 
                        className={`${styles.divisionItem} ${
                            division.deptPublicUri && division.deptPublicUri.trim() !== '' 
                                ? styles.clickable 
                                : ''
                        }`}
                        onClick={() => handleDepartmentClick(division.deptPublicUri)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleDepartmentClick(division.deptPublicUri);
                            }
                        }}
                    >
                        {division.deptName}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DivisionHome;
